module.exports = __webpack_public_path__ + "img/closeFile.1f1054c5.svg";